/**
 * The dev quick-login panel (task-dev-quick-login): its copy, the profiles
 * grouped by role, and whether the build offers it at all. The API is the
 * real gate; this only decides what the screen shows. Pure.
 */
import { ROLE_LABELS } from './roles.model';
import type { AdminRole } from '../types/api';

export interface QuickLoginProfile {
  id: number;
  username: string;
  fullName: string | null;
  role: string;
  isTest: boolean;
}

export const QUICK_LOGIN_LABELS = {
  title: 'Acceso rápido de desarrollo',
  subtitle: 'Entra como cualquier perfil de este entorno, sin contraseña. Solo existe en local y en dev, y cada acceso queda registrado.',
  secretLabel: 'Clave de acceso rápido',
  secretHelp: 'En el entorno dev publicado se pide una clave. Pedila al equipo; queda guardada solo en esta pestaña.',
  secretSubmit: 'Continuar',
  enter: 'Entrar',
  test: 'Prueba',
  empty: 'No hay perfiles disponibles para el acceso rápido.',
  unavailable: 'El acceso rápido no está habilitado en este entorno.',
  wrongSecret: 'La clave no es válida.',
  loadError: 'No se pudieron cargar los perfiles.',
  loginLink: 'Acceso rápido de desarrollo',
};

export const QUICK_LOGIN_SECRET_KEY = 'dev-quick-login-secret';

/** Whether this build offers the panel: a build-time flag, never set for production. */
export const quickLoginOffered = (flag: string | undefined): boolean => flag === 'true';

export function roleLabel(role: string): string {
  return ROLE_LABELS[role as AdminRole] ?? role;
}

/** Profiles grouped by role, roles in a stable order, people by name. */
export function groupByRole(profiles: QuickLoginProfile[]): Array<{ role: string; label: string; profiles: QuickLoginProfile[] }> {
  const order = ['admin', 'supervisor', 'backseller', 'telemarket', 'viewer'];
  const roles = [...new Set(profiles.map((p) => p.role))].sort((a, b) => (order.indexOf(a) + 99 * Number(order.indexOf(a) < 0)) - (order.indexOf(b) + 99 * Number(order.indexOf(b) < 0)));
  return roles.map((role) => ({
    role,
    label: roleLabel(role),
    profiles: profiles.filter((p) => p.role === role).sort((a, b) => (a.fullName ?? a.username).localeCompare(b.fullName ?? b.username)),
  }));
}
